import React from 'react';
import { Ruler, MapPin, GitBranch, GitMerge, FileText, Map } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { services } from '../constants';

const iconMap = {
  Ruler: Ruler,
  MapPin: MapPin,
  GitBranch: GitBranch,
  GitMerge: GitMerge,
  FileText: FileText,
  Map: Map
};

const Services = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Hizmetlerimiz</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Ağrı ili genelinde tüm harita mühendisliği ve kadastro hizmetlerinde profesyonel çözümler sunuyoruz.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-sky-200 group cursor-pointer"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-gradient-to-br from-sky-100 to-sky-200 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-7 h-7 text-sky-600" />
                  </div>
                  <CardTitle className="text-xl text-gray-900 group-hover:text-sky-600 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 border border-gray-200">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              Hizmetlerimiz Hakkında Detaylı Bilgi Alın
            </h3>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Arazi ölçümü, kadastro işlemleri veya diğer hizmetlerimiz hakkında detaylı bilgi ve fiyat teklifi için bizimle iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:04722159036" className="inline-flex items-center justify-center px-8 py-4 bg-sky-600 text-white rounded-lg hover:bg-sky-700 transition-colors font-semibold shadow-lg hover:shadow-xl">
                0472 215 90 36
              </a>
              <a href="tel:05326943690" className="inline-flex items-center justify-center px-8 py-4 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors font-semibold shadow-lg hover:shadow-xl">
                0532 694 36 90
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;